import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { HexColorPicker } from "react-colorful";

const IconColorSelector = ({ selectedColor, onColorSelect }) => {
  // Predefined colors with their names and hex values
  const predefinedColors = [
    { name: "Ruby Red", hex: "#E0115F" },
    { name: "Royal Blue", hex: "#4169E1" },
    { name: "Forest Green", hex: "#228B22" },
    { name: "Deep Purple", hex: "#663399" },
    { name: "Burnt Orange", hex: "#FF7F50" },
    { name: "Turquoise", hex: "#40E0D0" },
    { name: "Golden Yellow", hex: "#FFD700" },
    { name: "Hot Pink", hex: "#FF69B4" },
    { name: "Slate Gray", hex: "#708090" },
    { name: "Chocolate Brown", hex: "#D2691E" },
    { name: "Navy Blue", hex: "#000080" },
    { name: "Emerald Green", hex: "#50C878" },
  ];

  // Ensure selectedColor is a string
  const currentColor = typeof selectedColor === 'string' ? selectedColor : "#4169E1";

  return (
    <Box sx={{ width: "100%" }}>
      {/* Preview Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Preview Selected Color
        </Typography>
        <Box
          sx={{
            width: 100,
            height: 100,
            backgroundColor: currentColor,
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
      </Box>

      {/* Predefined Colors Section */}
      <Typography variant="h6" sx={{ mb: 2 }}>
        Select a Color
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {predefinedColors.map((color) => (
          <Grid item xs={3} sm={2} key={color.hex}>
            <Box
              onClick={() => onColorSelect(color.hex)}
              sx={{
                cursor: "pointer",
                textAlign: "center",
                border: currentColor === color.hex ? "3px solid #000" : "1px solid #ccc",
                borderRadius: "5px",
                padding: "10px",
                '&:hover': {
                  transform: 'scale(1.05)',
                  transition: 'transform 0.2s'
                }
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: 50,
                  backgroundColor: color.hex,
                  borderRadius: "3px",
                  mb: 1,
                }}
              />
              <Typography variant="caption" sx={{ display: "block" }}>
                {color.name}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Custom Color Picker Section */}
      <Typography variant="h6" sx={{ mb: 2 }}>
        Custom Color
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <Box sx={{ width: 200 }}>
          <HexColorPicker 
            color={currentColor} 
            onChange={(color) => {
              if (typeof onColorSelect === 'function') {
                onColorSelect(color);
              }
            }} 
          />
        </Box>
      </Box>
    </Box>
  );
};

export default IconColorSelector; 